export const roomSizeColumns = [
    {
        Header: 'Room Id',
        accessor: 'roomId',
    },
    {
        Header: 'Room Name',
        accessor: 'roomName',
    },
    {
        Header: 'Actions',
        accessor: 'actions',
    }
]

export const roomSizeData = [
    {
        roomId: '1101',
        roomName:'Single',
    },
    {
        roomId: '1102',
        roomName:'Deluxe',
    },
    {
        roomId: '1103',
        roomName:'Studio',
    },
    {
        roomId: '1104',
        roomName:'Junior Suite',
    },
    {
        roomId: '1105',
        roomName:'Queen',
    },
    {
        roomId: '1106',
        roomName:'King',
    },
    {
        roomId: '1107',
        roomName:'Cabana',
    },
    {
        roomId: '1108',
        roomName:'Connecting',
    },
    {
        roomId: '1109',
        roomName:'Quad',
    },
]